import SanjivaniYojna from "./SanjivaniYojna";
import SuvidhaYojana from "./SuvidhaYojana";
import SubscriptionPlan from "./SubscriptionPlan";
import SuretyDetails from "./SuretyDetails";
import { APICall } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { useContext, useEffect, useState } from "react";
import {
   GetMemberDashboardDetails ,
  GetMemberDashboardDetailsByYojnaController
} from "../../Helpers/APIEndPoints/EndPoints";
import notify, { ToastType } from "../../Helpers/ToastNotification";

const MemberDashboard = (props) => {
  const { appModule } = props;
  const context = getContext();
  let MemberId = context.MemberId;
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [memberData, setMemberData] = useState(null);
  const [memberDoj, setMemberDoj] = useState(null);
  const [sanjeevanDesc, setSanjeevanDesc] = useState("");
  const [suvidhaDesc, setSuvidhaDesc] = useState("");
  const [suretyDetails, setSuretyDetails] = useState([]);
  const getDashboardData = async () => {
    showLoader();
    try {
      const obj = { MemberId };
      const resp = await APICall(GetMemberDashboardDetailsByYojnaController, obj);
      if (resp.Message === "Success") {
        const memberData = resp?.Data?.MemberSubscriptionPlanList[0];
        const memberDoj = resp?.Data?.DOJ;
        const extractedDetails = resp?.Data?.MemberSuretyDetailsList?.map(
          ({ MemberNo, MemberName }) => ({ MemberNo, MemberName })
        );
        setSuretyDetails(extractedDetails);
        setMemberData(memberData);
        setMemberDoj(memberDoj);
        setSanjeevanDesc(resp?.Data?.Description_Sanjivani);
        setSuvidhaDesc(resp?.Data?.Description_Suvidha);
        setSuretyDetails(extractedDetails);
      }
    } catch (error) {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (MemberId) {
      getDashboardData();
    }
  }, [MemberId]);

  return (
    <div>
      <div className="row d-flex flex-row justify-content-center align-items-center flex-wrap">
        <div className="col-lg-6">
          <SanjivaniYojna appModule={appModule} sanjeevanDesc={sanjeevanDesc} />
        </div>
        <div className="col-lg-6">
          <SubscriptionPlan memberData={memberData} memberDoj={memberDoj} />
        </div>
      </div>

      <div className="row d-flex flex-row justify-content-center align-items-center flex-wrap">
        <div className="col-lg-6">
          <SuvidhaYojana appModule={appModule} suvidhaDesc={suvidhaDesc} />
        </div>
        <div className="col-lg-6">
          <SuretyDetails suretyDetails={suretyDetails} />
        </div>
      </div>
    </div>
  );
};

export default MemberDashboard;
